import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-account-delete-info',
  standalone: true,
  imports: [RouterLink, TranslateModule],
  templateUrl: './account-delete-info.component.html',
  styleUrl: './account-delete-info.component.scss',
})
export class AccountDeleteInfoComponent {
  public support_email = environment.support_email;
  public home_base = environment.site_base;
}
